module.exports = __webpack_public_path__ + "img/2.f7a427f.jpg";